import styled from 'styled-components';
import { fonts } from '@vfit/shared/themes';

const ContainerTopProduct = styled.div<{ haveTitle?: boolean }>`
  margin-top: ${({ haveTitle }) => (haveTitle ? '45px' : 0)};
  font-family: ${fonts.regular};
`;

export default ContainerTopProduct;
